import React, { useContext, useEffect } from "react";
import { Form as FormAntd, message } from "antd";
import { Layer } from "../../../../component/layer/layer";
import { InventoryGoodsFormBasic } from "./inventory_goods_form_basic";
import { Button } from "../../../../component/button";
import { outStockFormAction } from "../../action/out-stock/out_stock_form_action";
import { InventoryGoodsFormStore } from "../../store/inventory/inventory_goods_form_store";
import { inventoryAction } from "../../action/inventory/inventory_action";
import { inventoryGoodsFormAction } from "../../action/inventory/inventory_goods_form_action";
import { useBoolean } from "ahooks";

interface IForm {
    children?: any;
    action: any;
    close: (hasUpdate?: boolean) => void;
    id?: string;
    subId: string;
    method?: string;
    audit: boolean;
    item;
}
export function Form({ close, method, id, subId, item, audit }: IForm) {
    const [form] = FormAntd.useForm();

    const { state, dispatch } = useContext(InventoryGoodsFormStore);
    const [loading, loadFunc] = useBoolean(false)
    const action = inventoryGoodsFormAction;

    useEffect(() => {

        action.init({ state: state, dispatch, id, form, method });

        return () => {

        }
    }, []);

    const title = () => {
        if ("Create" === method) {
            return "新增商品盘点单";
        }
        else if ("Edit" === method) {
            return "编辑商品盘点单";
        }
        else {
            return "预览商品盘点单";
        }
    }

    return (
        <FormAntd form={form}>
            <Layer layerWith={4} >
                <Layer.Title onClick={() => close()}>{title()}</Layer.Title>
                <Layer.Body>
                    <InventoryGoodsFormBasic disabled={!("Create" == method || "Edit" == method)} updateFormField={(field, value = '') => {
                        form.setFieldsValue({
                            [field]: value,
                        });
                    }} />
                </Layer.Body>
                <Layer.Foot borderStyle={title() == '预览商品盘点单' ? { border: 'none' } : {}}>
                    {
                        ("Create" == method || "Edit" == method) && (
                            <Button type="primary" color="Yellow" style={{ marginRight: "1.25rem" }} onClick={async () => {
                                // await form.validateFields();
                                let formV = await form.validateFields();
                                if(loading){
                                    message.loading('正在提交数据')
                                    return false
                                }
                                let r = false;
                                if ("Create" == method) {
                                    loadFunc.setTrue()
                                    r = await action.addSubmit({ state, status: 2 });
                                    loadFunc.setFalse()
                                } else {
                                    loadFunc.setTrue()
                                    r = await action.updSubmit({ state, status: 2 }, id);
                                    loadFunc.setFalse()
                                }
                                if (r) {
                                    action.clearTableList({ dispatch });

                                    close(true);
                                }
                            }}>
                                保存并返回
                            </Button>
                        )
                    }
                    {
                        ("Create" == method || "Edit" == method && item.status == 2) && audit && (
                            <Button type="primary" color="Red" onClick={async () => {
                                // await form.validateFields();
                                let formV = await form.validateFields();
                                if(loading){
                                    message.loading('正在提交数据')
                                    return false
                                }
                                let r = false;
                                if ("Create" == method) {
                                    loadFunc.setTrue()
                                    r = await action.addSubmit({ state, status: 1 });
                                    loadFunc.setFalse()
                                } else {
                                    loadFunc.setTrue()
                                    r = await action.updSubmit({ state, status: 1 }, id);
                                    loadFunc.setFalse()
                                }
                                if (r) {
                                    action.clearTableList({ dispatch });

                                    close(true);
                                }
                            }}>
                                保存并审核
                            </Button>
                        )
                    }
                </Layer.Foot>

            </Layer>
        </FormAntd>
    )
}